<template>
	<iframe
		:src="`${url}?unbranded`"
		allowfullscreen>
	</iframe>
</template>

<script>
	export default {
		props: {
      url: {
        default: '',
        type: String
      }
    }
	}
</script>
